import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCEPdfTemplate from './ModalCEPdfTemplate'
import { PdfTemplateModelType, PdfTemplatePdfTypesTy } from '@teinor/erp/types/company/config/pdfTemplate'
import usePdfTemplateTypes from '../../../../../utils/hooks/pdf/usePdfTemplateTypes'
import { useLocation } from 'react-router-dom'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderBoolean, CustomRenderLanguageName, CustomRenderString, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import ModalDeletePdfTemplate from './ModalDeletePdfTemplate'

interface ConfigPdfTemplatesProps extends ComponentWithPermissions { }

const ConfigPdfTemplates: React.FC<ConfigPdfTemplatesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('documents', 'Documentos'),
        newText: t('newDocument', 'Nuevo documento'),
    }

    return (
        <BaseScreenTable TableComponent={TablePdfTemplates} CreateModalComponent={ModalCEPdfTemplate} EditModalComponent={ModalCEPdfTemplate} pageData={pageData} userPermissions={userPermissions} DeleteModalComponent={ModalDeletePdfTemplate}/>
    )
}

interface TablePdfTemplatesProps extends TableComponentProps { }

const TablePdfTemplates: React.FC<TablePdfTemplatesProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const { pdfTemplateTypes } = usePdfTemplateTypes()
    const location = useLocation().pathname

    const columns: ColumnTableSchema<PdfTemplateModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            width: 200,
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            width: 200,
            label: t('name', 'Nombre'),
            sortable: true,
        },
        {
            id: 'LangId',
            dataKey: 'LangId',
            label: t('language', 'Idioma'),
            customRender: (parameterValue) => <CustomRenderLanguageName languageId={parameterValue} />,
            generalSearchable: false
        },
        {
            id: 'type',
            dataKey: 'type',
            label: t('type', 'Tipo'),
            generalSearchable: false,
            customRender: (parameterValue) => <CustomRenderString value={pdfTemplateTypes[parameterValue as keyof PdfTemplatePdfTypesTy]?.name} /> 
        },
        {
            id: 'is_main',
            dataKey: 'is_main',
            label: t('default', 'Por defecto'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={65} />,
            width: 120
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[location, ['$id']]} name='pdfTemplates' columns={columns} getDataFrom='/api/app/config/pdfTemplate/getAllPdfTemplates' setTableInstance={setTableInstance} />
    )
}

export default ConfigPdfTemplates